// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_fLF","cls2":"Tabs-cls2_-qC Tabs-cls1_fLF","active":"Tabs-active_QfY"};